import React, { useState, useEffect, useRef, useContext } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import "./Inventory.scss";
import Loading from "../../../components/Loading/Loading";
import bg from "../../../assets/images/background.png";
import Button from "../../../components/Button/Button";
import AnimatedModal from "../../../components/Modal/AnimatedModal";
import AssignInventory from "./AssignInventory";
import { encryptStorage } from "../../../helper/storage";
import CreatedLicenseCard from "./Component/CreatedLicenseCard/CreatedLicenseCard";
import Scroller from "../../../components/Scroller/ScrollBar";

import AssignInventoryModal from "./Component/AssignInventoryModal/AssignInventoryModal";
import { API_URL, axiosApiInstance } from "../../../helper/request";
import InputBox from "../../../components/Inputbox/InputBox";
import { useDebouncedEffect } from "../../../helper/useDebounce";
import { ThemeContext } from "../../../helper/context";
import { searchIcon } from "../../../helper/icons";
let changePage = 1;
let flag = false;
let removeMfgData = [];

let msg = {
  type: "alert",
  header: "Error",
  errorText: "Something Went Wrong",
};
let Role = [];

export default function Inventory() {
  const [assignChildMfg, setAssignChildMfg] = useState(false);
  const [createLicenseOpen, setCreateLicenseCard] = useState(false);
  const [ShowAlert, setShowAlert] = useState(false);
  const [remainingCount, setRemainingCount] = useState(0);
  const [focusCount, setFocusCount] = useState(0);
  const [attributeData, setAttributeData] = useState([]);
  const [createdLicense, setCreatedLicense] = useState();
  const [searchLicense, setSearchLicense] = useState(undefined);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [totalCount, setTotalCount] = useState(15);
  const [items, setItems] = useState(8);
  const [assignType, setAssignType] = useState("");
  const [assignLicenseName, setAssignLicenseName] = useState();
  const [attributeDataArr, setAttributeDataArr] = useState([]);
  const [mfrDetails, setmfrDetails] = useState({});
  const [totalMfgCount, setTotalMfgCount] = useState();
  const [userFlag, setUserFlag] = useState(false);

  const themeContext = useContext(ThemeContext);

  const scrollbar = useRef(null);

  const handleScroll = () => {
    if (scrollbar.current.getValues().top > 0.95 && totalCount > items) {
      if (changePage <= Math.floor(totalCount / items) && !flag) {
        flag = true;
        changePage += 1;
        getCreatedLicense(changePage);
      }
    } else if (
      scrollbar.current.getValues().top === 0 &&
      console.log(changePage > 1 && !flag)
    ) {
      changePage -= 1;
      flag = true;
      getCreatedLicense(changePage);
    }
  };

  useDebouncedEffect(
    () => {
      if (searchLicense?.length >= 3) {
        searchLicenseDetails();
      }
      if (searchLicense?.length === 0) {
        getCreatedLicense();
      }
    },
    [searchLicense],
    1000
  );

  useEffect(() => {
    // getAttributeName();
    getCreatedLicense();
    let dataa = encryptStorage.getItem("UID").roles;
    Role = dataa;
  }, []);

  const searchLicenseDetails = () => {
    let url = ``
    if (themeContext.Role.all.includes("superadmin")) {
      url = `inventory/admin/special_plans?license_type=device&page=${changePage}&items=${items}`;
    }
    if (themeContext.Role.all.includes("user")) {
      url = `inventory/role?license_type=device&page=${changePage}&items=${items}`;
    }
    let inventoryLicense = "";
    if (searchLicense !== undefined && searchLicense !== "") {
      inventoryLicense = `&licensename=${searchLicense}`;
    }
    if (inventoryLicense !== "") {
      url += inventoryLicense;
      axiosApiInstance.get(API_URL + url).then((res) => {
        setCreatedLicense(res.data.details);
      });
    }
  };

  const getMfgNames = (assignLicenseName, role, page) => {
    if (role === "manufacturer") {
      axiosApiInstance
        .get(
          `inventory/manufacturer/distribution?role=${role}&license_name=${assignLicenseName}&page=${page}&items=10`
        )
        .then((res) => {
          let data = {};
          for (let i = 0; i < res.data.details.length; i++) {
            removeMfgData.push(res.data.details[i].username);
          }

          res.data.details.map((item) => {
            data[item.inventory_owner.username] = {
              prev: item["total_count"],
              current: 0,
              total: item["total_count"],
            };
            // item["count"] = {
            //   prev: item["total_count"],
            //   current: 0,
            //   total: item["total_count"],
            // };
          });
          setmfrDetails(data);
          // customMfrDetails(data)
        })
        .catch((err) => { });
    } else {
      axiosApiInstance
        .get(
          `inventory/manufacturer/distribution?role=${(role =
            "user")}&license_name=${assignLicenseName}&page=${page}&items=10`
        )
        .then((res) => {
          // let data = {}
          setUserFlag(false);
          let data = page === 1 ? {} : { ...mfrDetails };
          setTotalMfgCount(res.data.total_count);
          res.data.details.map((item) => {
            data[item.inventory_owner.username] = {
              prev: item["total_count"],
              current: 0,
              total: item["total_count"],
            };
            // customMfrDetails(res.data.details)
          });
          setTimeout(() => {
            setLoadingScreen(false);
            setmfrDetails({ ...data });
          }, 1000);
        });
    }
  };

  const getAttributeName = () => {
    // setLoadingScreen(true)
    axiosApiInstance
      .get("inventory/created/recent?license_type=device")
      .then((res) => {
        let data = [];
        Object.keys(res.data.details).map((key) => {
          data.push({
            Name: key,
            Quantity: res.data.details[key],
          });
        });
        setAttributeData(data);
        attributeDataArr.push(data.map((item) => item.Name));

        for (let i = 0; i < res.data.details.length; i++) {
          console.log("tt");
          console.log(res.data.details, "kkkkkk");
        }
        // setAttributeName(res.data.detail);
        // let arr = [...res.data.detail];
        // let newObj = {};
        // res.data.detail.map((attributeName) => (newObj[attributeName] = 0));
        // setAttributeData(newObj);
      })
      .catch((err) => { })
      .finally(() => {
        // setLoadingScreen(false)
      });
  };

  const getCreatedLicense = () => {
    setLoadingScreen(true);
    let url = `inventory/admin/special_plans?license_type=device&page=${changePage}&items=${items}`;
    if (themeContext.Role.all.includes("user")) {
      url = `inventory/role?license_type=device&page=${changePage}&items=${items}`;
    }
    axiosApiInstance
      .get(url)
      .then((res) => {
        flag = false;
        let _data = [];
        setTotalCount(res.data.total_count);
        let arr = changePage === 1 ? [] : [...createdLicense];
        for (let i = 0; i < res.data.details.length; i++) {
          // removeMfgData.push(res.data.details[i].username);
          arr.push(res.data.details[i]);
        }
        setTimeout(() => {
          setLoadingScreen(false);
          setCreatedLicense([...arr]);
        }, 1000);
        // if (res.data.details?.length <= items / 2) {
        //   createdLicense?.splice(0, items / 2);
        //   if (res.data.total_count > 4) {
        //     _data = [...createdLicense];
        //   }
        //   if (res.data.total_count <= 4) {
        //     // _data = res.data.details;
        //   }
        // }
        // res.data.details?.length === 0
        //   ? setSearchLicense(undefined)
        //   : res.data.details.map((item) => _data.push(item));
        // setTimeout(() => {
        //   setLoadingScreen(false);
        //   setCreatedLicense(_data);
        //   scrollbar?.current?.scrollTop(20);
        // }, 1000);
      })
      .catch((err) => {
        // setLoadingScreen(false);
      })
      .finally(() => {
        // setLoadingScreen(false)
      });
  };

  const renderWithSearchBar = () => {
    return (
      <div className="inventory_upper_data">
        {console.log(attributeDataArr, "attributeDataArr")}
        <InputBox
          id="search"
          placeholder="Search by license name"
          onChange={(e) => {
            changePage = 1;
            setSearchLicense(e.target.value);
          }}
          value={searchLicense}
          children={searchIcon()}
        />
        <div className="add_plan_btn">
          {Role.includes("superadmin") && (
            <Button
              onClick={() => {
                setCreateLicenseCard(true);
                getAttributeName();
              }}
              name="Create plan"
            />
          )}
        </div>
      </div>
    );
  };
  const renderNoSearchBar = () => {
    return (
      <>
        <div className="inventory_nosearch_data">
          <div className="add_plan_btn">
            {Role.includes("superadmin") && (
              <Button
                onClick={() => {
                  setCreateLicenseCard(true);
                  getAttributeName();

                }}
                name="Create Plan"
              />
            )}
          </div>
        </div>
        <div className="no_plan">
          {emptyLicenseIcon()}
          <p className="no_plan_label"> No plans found</p>
          {Role.includes("superadmin") && (
            <p
              onClick={() => {
                setCreateLicenseCard(true);
              }}
              className="create_plan_label"
            >
              Create plan
            </p>
          )}
        </div>
      </>
    );
  };

  const [openAssignInventoryModal, setOpenAssignInventoryModal] =
    useState(false);
  const onInventoryPlanAssignClick = () => {
    setOpenAssignInventoryModal(true);
  };

  return (
    <div className="__users_wrapper__ __inventory__">
      <Navbar sidenav>
        <div className="users_body">
          <img src={bg} className="profile_bg" />
          <div className="body_content">
            <div>
              <p className="special_plan_tag">
                {Role.includes("user") ? "Inventory" : "Special Plan"}
              </p>
              <div className="inventory_data">
                <>
                  {createdLicense?.length === 0 ? (
                    searchLicense === undefined ? (
                      createdLicense?.length === 0 && renderNoSearchBar()
                    ) : (
                      <>
                        {renderWithSearchBar()}
                        <div className="no_plan">
                          {emptyLicenseIcon()}
                          <p className="no_plan_label"> No plans found</p>
                          {/* {Role.includes("superadmin") && (
                            <p
                              onClick={() => {
                                setCreateLicenseCard(true);
                              }}
                              className="create_plan_label"
                            >
                              Create plan
                            </p>
                          )} */}
                        </div>
                      </>
                    )
                  ) : (
                    <>
                      {renderWithSearchBar()}
                      <Scroller
                        autoHeightMax="55vh"
                        verticalStyle={{
                          width: "0.2vw",
                          marginLeft: "0vw",
                          backgroundColor: "#283e92",
                          overflow: "hidden",
                        }}
                        onScroll={handleScroll}
                        ref={scrollbar}
                      >
                        <div
                          className="added_license_wrapper"
                        >
                          {createdLicense?.map((item) => (
                            <CreatedLicenseCard
                              assignChildMfg={assignChildMfg}
                              assignClick={() => {
                                setRemainingCount(item.total_count);
                                setFocusCount(item.total_count);
                                // getMfgNames(
                                //   item.license_name,
                                //   "manufacturer",
                                //   1
                                // );
                              }}
                              setAssignChildMfg={setOpenAssignInventoryModal}
                              Attributedata={attributeData}
                              setAttributeData={setAttributeData}
                              licenseName={item?.license_name}
                              licenseDuration={item?.license_duration}
                              licenseDetails={item?.license_details}
                              licenseQuantity={item?.total_count}
                              item={item}
                              setAssignType={setAssignType}
                              setAssignLicenseName={setAssignLicenseName}
                              msg={msg}
                              setShowAlert={setShowAlert}
                            />
                          ))}
                        </div>
                      </Scroller>
                    </>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
      {loadingScreen && <Loading type={"transparent"} text={"Loading"} />}

      <AnimatedModal
        modalOpen={openAssignInventoryModal}
        className="upgrade_licence_modal"
      >
        <AssignInventoryModal
          licenseName={assignLicenseName}
          availableCount={focusCount}
          remainingCount={remainingCount}
          setRemainingCount={setRemainingCount}
          setOpenAssignInventoryModal={setOpenAssignInventoryModal}
          ShowAlert={ShowAlert}
          setShowAlert={setShowAlert}
          msg={msg}
          fetchLicense={getCreatedLicense}
        />
      </AnimatedModal>

      {/* <AssignChildMfg
        assignChildMfg={assignChildMfg}
        setAssignChildMfg={setAssignChildMfg}
        createdLicenseData={createdLicense}
        assignType={assignType}
        assignLicenseName={assignLicenseName}
        setShowAlert={setShowAlert}
        ShowAlert={ShowAlert}
        msg={msg}
      RemainingCount={remainingCount}
        setRemainingCount={setRemainingCount}
        focusCount={focusCount}
        setFocusCount={setFocusCount}
        constantCount={constantCount}
        mfrDetails={mfrDetails}
        setmfrDetails={setmfrDetails}
        Role={Role}
        role={role}
        setRole={setRole}
        removeMfgData={removeMfgData}
        manufacturerName={manufacturerName}
        getMfgNames={getMfgNames}
        totalMfgCount={totalMfgCount}
        setTotalMfgCount={setTotalMfgCount}
        newAddedUser={newAddedUser}
        setNewAddedUser={setNewAddedUser}
        // changeUserPage= {changeUserPage}
        // setChangeUserPage={setChangeUserPage}
      /> */}
      <AnimatedModal
        modalOpen={ShowAlert}
        handleClose={() => {
          setShowAlert(false);
        }}
        type={msg.type}
        errorHeader={msg.header}
        errorText={msg.errorText}
        // timeout={5000}
        alwayOpen={true}
      />
      <AssignInventory
        Attributedata={attributeData}
        setAttributeData={setAttributeData}
        createLicenseOpen={createLicenseOpen}
        setCreateLicenseCard={setCreateLicenseCard}
        getCreatedLicense={getCreatedLicense}
        setAttributeDataArr={setAttributeDataArr}
        attributeDataArr={attributeDataArr}
        msg={msg}
        ShowAlert={ShowAlert}
        setShowAlert={setShowAlert}
      />
    </div>
  );
}

const emptyLicenseIcon = () => {
  return (
    <svg
      width={143}
      height={143}
      viewBox="0 0 143 143"
      style={{ width: "10vw", height: "10vw" }}
      fill="none"
      className="emptyLicenseIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_48_388)">
        <path
          d="M142.745 70.472C142.745 70.4682 142.748 70.465 142.752 70.465V70.465C142.756 70.465 142.759 70.4618 142.759 70.4579C142.757 65.5138 140.821 61.0219 137.673 57.6706C137.672 57.6689 137.672 57.6663 137.673 57.6647V57.6647C137.675 57.6632 137.675 57.6608 137.674 57.6591L111.181 23.6305C110.619 22.9079 109.754 22.4854 108.838 22.4854H32.9926C32.052 22.4854 31.1671 22.931 30.6071 23.6867L4.90465 58.3692C4.90198 58.3728 4.90235 58.3778 4.90552 58.381V58.381C4.90885 58.3843 4.90907 58.3897 4.90603 58.3933C2.51884 61.22 1.00478 64.7728 0.630719 68.6576C0.591609 69.0638 0.463432 69.4549 0.345416 69.8455C0.278361 70.0675 0.238403 70.3003 0.238403 70.5465V117.234C0.238403 118.787 1.49665 120.043 3.04683 120.043H139.953C141.506 120.043 142.762 118.788 142.762 117.234V70.5465C142.762 70.5209 142.748 70.4973 142.745 70.472ZM33.1597 29.4182C33.711 28.5957 34.636 28.1022 35.6261 28.1022H106.294C107.259 28.1022 108.163 28.5706 108.719 29.3583L124.246 51.3382C124.371 51.5149 124.241 51.7398 124.025 51.7398V51.7398H93.3085C91.6687 51.7398 90.3393 53.0692 90.3393 54.709V60.1589C90.3393 69.7184 80.3023 67.6514 77.2248 67.6514H66.0083C62.9304 67.6514 52.8938 69.7184 52.8938 60.1589V54.709C52.8938 53.0692 51.5644 51.7398 49.9246 51.7398H19.2054V51.7398C18.7739 51.7398 18.5041 51.282 18.7444 50.9236L33.1597 29.4182ZM137.145 111.457C137.145 113.097 135.816 114.426 134.176 114.426H8.8269C7.18704 114.426 5.85768 113.097 5.85768 111.457V70.5465V70.5465C5.85768 70.5018 5.87952 70.465 5.92427 70.465H5.97172C6.03734 70.465 6.09048 70.4112 6.09107 70.3456C6.15542 63.1718 12.0136 57.356 19.2051 57.356H44.474C46.0218 57.356 47.2766 58.6107 47.2766 60.1585V60.1585C47.2766 69.8276 54.6288 73.2675 66.008 73.2675H77.2244C88.6064 73.2675 95.9558 69.8276 95.9558 60.1585V60.1585C95.9558 58.6107 97.2106 57.356 98.7584 57.356H124.03C127.644 57.356 130.922 58.8246 133.297 61.1977L133.303 61.2033C135.674 63.5742 137.139 66.8449 137.142 70.4551C137.142 70.4605 137.146 70.465 137.152 70.465V70.465C137.157 70.465 137.162 70.4694 137.161 70.4748C137.158 70.499 137.145 70.5215 137.145 70.5465L137.145 111.457Z"
          fill="#367BC0"
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_48_388">
          <rect
            width={142.523}
            height={142.523}
            fill="white"
            transform="translate(0.238281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

